var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShop1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 17,
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Screen 1 - Products/Grid view",
    clipPath: "url(#clip0_464_61312)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    transform: "translate(-24 -598)",
    fill: "#10141B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Navigation Panel",
    clipPath: "url(#clip1_464_61312)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 1080,
    transform: "translate(-24 -598)",
    fill: "#1E2631"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 63",
    clipPath: "url(#clip2_464_61312)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 822.97,
    transform: "translate(-24 -598)",
    fill: "#1E2631"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Navigation Menu",
    clipPath: "url(#clip3_464_61312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 145"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nav List Item"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_464_61312",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24 -15.0303H196V32.9697H-24V-15.0303Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M196 31.9697H-24V33.9697H196V31.9697Z",
    fill: "#262E3E",
    mask: "url(#path-1-inside-1_464_61312)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "shop 1",
    clipPath: "url(#clip4_464_61312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3672 9.59253H9.19313C8.59812 9.59253 8.11426 10.0764 8.11426 10.6714V12.3387C8.11426 12.9338 8.59812 13.4176 9.19313 13.4176H11.3672C11.9622 13.4176 12.4461 12.9338 12.4461 12.3387V10.6714C12.4461 10.0764 11.9622 9.59253 11.3672 9.59253ZM11.6615 12.3387C11.6615 12.5022 11.5274 12.633 11.3672 12.633H9.19313C9.02966 12.633 8.89889 12.4989 8.89889 12.3387V10.6714C8.89889 10.5079 9.03293 10.3772 9.19313 10.3772H11.3672C11.5307 10.3772 11.6615 10.5112 11.6615 10.6714V12.3387Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 6.5619C16 6.49324 15.9837 6.42785 15.9477 6.36901L13.5676 2.18429C13.499 2.06333 13.3682 1.98486 13.2276 1.98486H2.76911C2.62852 1.98486 2.49775 2.06006 2.4291 2.18429L0.052309 6.36901C0.0196159 6.42785 0 6.49324 0 6.5619C0 7.50019 0.565591 8.30444 1.37311 8.66079V15.5623C1.37311 15.7781 1.54965 15.9546 1.76543 15.9546H3.93298C3.93625 15.9546 3.93952 15.9546 3.94279 15.9546H6.98325C6.98651 15.9546 6.98978 15.9546 6.99305 15.9546H14.2313C14.4471 15.9546 14.6236 15.7781 14.6236 15.5623V8.70983C14.6236 8.69349 14.6236 8.68041 14.6204 8.66733C15.4311 8.31098 16 7.50346 16 6.5619ZM2.99796 2.77277H12.9988L14.859 6.04535H1.14099L2.99796 2.77277ZM11.387 6.82671C11.2628 7.53288 10.6449 8.06905 9.90274 8.06905C9.16061 8.06905 8.54271 7.53288 8.41847 6.82671H11.387ZM7.5848 6.82671C7.46056 7.53288 6.84267 8.06905 6.10053 8.06905C5.3584 8.06905 4.7405 7.53288 4.613 6.82671H7.5848ZM0.810789 6.82671H3.78259C3.65836 7.53288 3.03719 8.06905 2.29506 8.06905C1.55292 8.07232 0.935023 7.53288 0.810789 6.82671ZM6.59093 15.17H4.3351V10.9362C4.3351 10.6289 4.58357 10.3772 4.89416 10.3772H6.03515C6.34246 10.3772 6.5942 10.6256 6.5942 10.9362V15.17H6.59093ZM13.839 15.17H7.37556V10.9362C7.37556 10.1974 6.77401 9.59255 6.03188 9.59255H4.89089C4.15202 9.59255 3.5472 10.1941 3.5472 10.9362V15.1733H2.15774V8.85368C2.20351 8.85695 2.24928 8.85695 2.29506 8.85695C3.08623 8.85695 3.78586 8.45483 4.19779 7.84347C4.60973 8.45483 5.30936 8.85695 6.10053 8.85695C6.8917 8.85695 7.58807 8.45483 8.00327 7.84347C8.4152 8.45483 9.11483 8.85695 9.90274 8.85695C10.6939 8.85695 11.3903 8.45483 11.8022 7.84347C12.2141 8.45483 12.9138 8.85695 13.7049 8.85695C13.7507 8.85695 13.7932 8.85368 13.839 8.85368V15.17ZM13.7049 8.07232C12.9628 8.07232 12.3449 7.53615 12.2207 6.82998H15.1925C15.065 7.53288 14.4471 8.07232 13.7049 8.07232Z",
    fill: "currentColor"
  })))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_464_61312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "currentColor",
    transform: "translate(-24 -598)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_464_61312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 1080,
    fill: "currentColor",
    transform: "translate(-24 -598)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_464_61312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 822.97,
    fill: "currentColor",
    transform: "translate(-24 -598)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_464_61312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 479.97,
    fill: "currentColor",
    transform: "translate(-24 -255)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_464_61312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor",
    transform: "translate(0 0.969727)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop1);
export default __webpack_public_path__ + "static/media/shop-1.260dfc84cf402fc90a70fbcf88ba8f9f.svg";
export { ForwardRef as ReactComponent };